import { React, Box, CssBaseline, styled } from '../../utils/globalImports';
import { Header, Sidebar, Footer } from '../../utils/globalImports';

// Define the type of props for AppLayout, including children
interface AppLayoutProps {
    children: React.ReactNode;
}

const drawerWidth = 240;

const Main = styled('main', {
    shouldForwardProp: (prop) => prop !== 'open',
})<{ open?: boolean }>(({ theme, open }) => ({
    // flex: '1 0 auto' → grows with content (flex-basis: auto = natural height).
    // flex-shrink: 0 prevents the item from being capped at the parent's height,
    // so the outer minHeight: 100vh container grows with the content naturally.
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 0,
    padding: theme.spacing(3),
     paddingBottom: 1,
    marginLeft: `-${drawerWidth}px`,
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
    const [open, setOpen] = React.useState(true);

    return (
        // minHeight: 100vh keeps the layout full-screen for short pages.
        // When content is tall the container grows beyond 100vh and the
        // browser's native scrollbar appears — no internal scroll container needed.
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            overflow: 'hidden'
        }}>
            <CssBaseline />
            <Header />
            {/* flex: '1 0 auto' mirrors Main so the row also grows with content */}
            <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden', minHeight: 0 }}>
                <Sidebar open={open} />
                <Main open={open} sx={{ width: '80vw' }}>
                    {children}
                </Main>
            </Box>
            <Footer />
        </Box>
    );
};

export default AppLayout;
